import type { ReactNode } from "react";
import { WarningCircle } from "@/components/shared/icons";
import { Typography } from "@/components/shared/typography";
import { View } from "@/components/ui";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

type TooltipProps = {
  content: ReactNode;
  trigger?: ReactNode;
  contentClassName?: string;
  bodyClassName?: string;
};

export function Tooltip({ content, trigger, contentClassName, bodyClassName }: TooltipProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        {trigger ?? (
          <View className="cursor-pointer">
            <WarningCircle className="scale-y-[-1] transform" />
          </View>
        )}
      </DropdownMenuTrigger>

      <DropdownMenuContent className={cn("-left-10 p-2 px-3", contentClassName)}>
        <View className={cn("max-w-[311px]", bodyClassName)}>
          {typeof content === "string" ? (
            <Typography variant="body-md">{content}</Typography>
          ) : (
            content
          )}
        </View>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
